import { Loader } from "@fanduel/og-fe-library";
import { Suspense } from "react";
import Link from "@/components/link/Link";
import { API_EXIT_PREVIEW } from "../../constants";
import styles from "./previewSuspense.module.scss";

type PreviewSuspenseProps = {
  children?: React.ReactNode;
};

const PreviewSuspense = ({ children }: PreviewSuspenseProps) => (
  <Suspense fallback={<Loader />}>
    {children}
    <div className={styles.link}>
      <Link href={API_EXIT_PREVIEW} next>
        Exit Preview
      </Link>
    </div>
  </Suspense>
);

export default PreviewSuspense;
